import { type StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface TimeWindowsState {
    selectedDayKey: string | null;
    selectedTimeWindowId: string | undefined;
    selectedReasonCode: string;
    hasSubmitError: boolean;
}

interface TimeWindowsActions {
    setSelectedDayKey: (selectedDayKey: string | null) => void;
    setSelectedTimeWindowId: (selectedTimeWindowId: string | undefined) => void;
    setSelectedReasonCode: (selectedReasonCode: string) => void;
    setHasSubmitError: (hasSubmitError: boolean) => void;
}

interface State extends TimeWindowsState, TimeWindowsActions {}

const storeName = 'time-window-update-store';

const createTimeWindowsStore: StateCreator<State, [['zustand/devtools', never]], [], State> = (set) => ({
    selectedDayKey: null,
    selectedTimeWindowId: undefined,
    selectedReasonCode: '',
    hasSubmitError: false,

    setSelectedDayKey: (selectedDayKey) => {
        set({ selectedDayKey });
    },
    setSelectedTimeWindowId: (selectedTimeWindowId) => {
        set({ selectedTimeWindowId });
    },
    setSelectedReasonCode: (selectedReasonCode) => {
        set({ selectedReasonCode });
    },
    setHasSubmitError: (hasSubmitError) => {
        set({ hasSubmitError });
    },
});

export const useTimeWindowUpdateStore = create<State>()(
    devtools(createTimeWindowsStore, {
        name: storeName,
    })
);
